var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderRow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_872_16739)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 3.75C4.1444 3.75 3.75 4.19312 3.75 4.625V6.75H16.25V4.625C16.25 4.19312 15.8556 3.75 15.25 3.75H4.75ZM3.75 14.375V12.5H7V15.25H4.75C4.1444 15.25 3.75 14.8069 3.75 14.375ZM7 11H3.75V8.25H7V11ZM8.5 15.25V12.5H11.6667V15.25H8.5ZM13.1667 15.25H15.25C15.8556 15.25 16.25 14.8069 16.25 14.375V12.5H13.1667V15.25ZM13.1667 11H16.25V8.25H13.1667V11ZM11.6667 8.25H8.5V11H11.6667V8.25ZM2.25 4.625C2.25 3.26195 3.4226 2.25 4.75 2.25H15.25C16.5774 2.25 17.75 3.26195 17.75 4.625V14.375C17.75 15.738 16.5774 16.75 15.25 16.75H4.75C3.4226 16.75 2.25 15.738 2.25 14.375V4.625Z",
    fill: "#2B2B35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_872_16739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderRow);
export default __webpack_public_path__ + "static/media/header_row.abe17fedefe51010df0e228b322671fa.svg";
export { ForwardRef as ReactComponent };